module.exports = __webpack_public_path__ + "static/media/workspaces-license.e869b8a0.png";